import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

/**
 * IntentCard - Expandable card showing detected intents and optional plan steps.
 *
 * @param {Array}  intents - Array of intent objects with action/object fields
 * @param {Array}  steps   - Optional array of plan step strings
 */
const IntentCard = ({ intents = [], steps = [] }) => {
  const [expanded, setExpanded] = useState(false);
  const hasSteps = steps.length > 0;

  return (
    <div className="border border-edge-border bg-surface-muted rounded-lg overflow-hidden">
      <div
        className="flex items-center justify-between px-3 py-3 sm:px-[12px] sm:py-[14px] cursor-pointer select-none"
        onClick={() => setExpanded((v) => !v)}
      >
        <p className="text-[12px] font-medium text-ink-ink dark:text-ink-white">
          {intents.length === 1 ? "1 intent detected" : `${intents.length} intents detected`}
        </p>
        <span className="text-ink-gray-500 dark:text-ink-gray-400 flex-shrink-0 ml-2">
          {expanded ? <ChevronUp size={14} strokeWidth={2.5} /> : <ChevronDown size={14} strokeWidth={2.5} />}
        </span>
      </div>
      {expanded ? (
        <div className="border-t border-edge-border bg-surface-page px-3 py-3 sm:px-[12px] space-y-3">
          <ol className="space-y-1 list-none m-0 p-0">
            {intents.map((intent, i) => (
              <li key={i} className="flex items-start gap-2 text-[13px] leading-5 text-ink-ink dark:text-ink-white">
                <span className="flex-shrink-0 text-ink-gray-500 dark:text-ink-gray-400 w-4">{i + 1}.</span>
                <span className="min-w-0 break-words">
                  <span className="font-semibold capitalize">{intent.action}</span>
                  {intent.object ? <span className="text-ink-gray-500 dark:text-ink-gray-400"> · {intent.object}</span> : null}
                </span>
              </li>
            ))}
          </ol>
          {hasSteps && (
            <div className="border-t border-edge-border pt-3">
              <p className="text-[11px] font-medium text-ink-gray-500 dark:text-ink-gray-400 mb-2">Steps</p>
              <ol className="space-y-1 list-none m-0 p-0">
                {steps.map((step, i) => (
                  <li key={i} className="flex items-start gap-2 text-[13px] leading-5 text-ink-ink dark:text-ink-white">
                    <span className="flex-shrink-0 text-ink-gray-500 dark:text-ink-gray-400 w-4">{i + 1}.</span>
                    <span className="min-w-0 break-words">{step}</span>
                  </li>
                ))}
              </ol>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default IntentCard;
